import { LoadingStatus } from '../../shared/status';
import { IDeveloperInitialState } from './types';

const initialState: IDeveloperInitialState = {
	accessKeys: [],
	isLoading: LoadingStatus.NEVER,
};

export default initialState;